import { dnActionTypes } from '../actions/dnActions';

const DNReducers = (state = { }, action) => {
  switch (action.type) {
  case dnActionTypes.GET_DN.LOADING: {
    const { getDNLoading } = action;
    return {
      ...state,
      getDNLoading,
    };
  }
  case dnActionTypes.GET_DN.SUCCESS: {
    const { debitNotes } = action;
    return {
      ...state,
      debitNotes,
    };
  }
  case dnActionTypes.GET_DN_BY_ID.LOADING: {
    const { getDNByIdLoading } = action;
    return {
      ...state,
      getDNByIdLoading,
    };
  }
  case dnActionTypes.GET_DN_BY_ID.SUCCESS: {
    const { selectedDN } = action;
    return {
      ...state,
      selectedDN,
    };
  }
  case dnActionTypes.CREATE_DN.LOADING: {
    const { createDNLoading } = action;
    return {
      ...state,
      createDNLoading,
    };
  }
  case dnActionTypes.UPDATE_DN.LOADING: {
    const { updateDNLoading } = action;
    return {
      ...state,
      updateDNLoading,
    };
  }
  case dnActionTypes.UPDATE_STATUS_DN.LOADING: {
    const { updateDNStatusLoading } = action;
    return {
      ...state,
      updateDNStatusLoading,
    };
  }
  case dnActionTypes.DELETE_DN.LOADING: {
    const { deleteDNLoading } = action;
    return {
      ...state,
      deleteDNLoading,
    };
  }
  case dnActionTypes.UPDATE_DN_WORKFLOW_STEP.LOADING: {
    const { updateDNWorkflowStepLoading } = action;
    return {
      ...state,
      updateDNWorkflowStepLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default DNReducers;
